import {
  Box,
  CircularProgress,
  FormControl,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import './DocumentHubPage.scss';
import { DocumentUploadButton } from './DocumentUploadButton';
import { DocumentHubTableFolders } from './DocumentHubTableFolders';
import { useState } from 'react';
import { DocumentHubTableDocuments } from './DocumentHubTableDocuments';
import { useGetDocumentTree } from '../../api/documentHub';
import { useTitle } from '../../hooks/useTitle.ts';

export const DocumentHubPage = () => {
  useTitle('Document Hub - Immersive Homes');
  const selectStyles = {
    '& .MuiSelect-outlined': {
      padding: '4px',
      paddingLeft: '24px',
      'paddingRight:': '24px',
      textAlign: 'center',
      border: 'unset',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'unset',
    },
  };

  const options = ['Folders', 'Documents'];

  const [selectedSortOrder, setSelectedSortOrder] = useState('Folders');
  const [folderView, setFolderView] = useState(false);
  const { data: folders, loading } = useGetDocumentTree();

  const LoadingScreen: React.FunctionComponent = () => {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
        }}
      >
        <CircularProgress sx={{ marginRight: '8px' }} />
        <Typography>Loading Documents...</Typography>
      </Box>
    );
  };

  return (
    <Box className="document-hub">
      <Box className="text-container">
        <Typography variant="h1">Document Hub</Typography>
        <Typography>
          Upload and manage project, financing, contractual and other
          documentation
        </Typography>
      </Box>

      <>
        {!loading && folders ? (
          <>
            <Box className="button-container">
              <Box sx={{ minWidth: 240 }}>
                <FormControl fullWidth>
                  <Select
                    variant="filled"
                    sx={{
                      ...selectStyles,
                      visibility: folderView ? 'hidden' : 'visible',
                    }}
                    value={selectedSortOrder}
                    onChange={(e) => setSelectedSortOrder(e.target.value)}
                  >
                    {options.map((option, i) => (
                      <MenuItem key={i} value={option}>
                        {`View: ${option}`}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
              <DocumentUploadButton />
            </Box>
            <Box sx={{ height: '100%' }}>
              {selectedSortOrder === 'Folders' && folders ? (
                <DocumentHubTableFolders
                  folders={folders || undefined}
                  folderView={folderView}
                  setFolderView={setFolderView}
                />
              ) : (
                <DocumentHubTableDocuments folderType={'All'} />
              )}
            </Box>
          </>
        ) : (
          <LoadingScreen />
        )}
      </>
    </Box>
  );
};
